module.exports = __webpack_public_path__ + "static/media/timder.51e93889.mp4";